export default __webpack_public_path__ + "static/media/component_pc_motor_driver.7cb56436.png";